import React from "react";
import "./Style.css";
import ReactModal from "react-modal";
import { TbKey } from "react-icons/tb";
import { useState } from "react";
import { CreateKey, getAll } from "../../../../services/pix.service";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../../hooks/useAuth";
import { PullerGetAllPixKeyList, MethodToCache, MessageToCache } from "../../../../services/puller.service";

const CadastrarChaveModal = ({createPixKeyModal, setCreatePixKeyModal, refreshList, setIsWaitDBChange}) => {
  const [keyType, setKeyType] = useState();
  const [passwordRequired, setPasswordRequired] = useState(false);
  const [transationalPassword, setTransationalPassword] = useState();

  const { account } = useAuth()

  const navigate = useNavigate();

  const confirm = () => {
    const bank = account.bank;

    if (bank != "450") {
      setPasswordRequired(true);
    } else {
      createPixKey();
    }
  };

  const closeModal = () => {
    setCreatePixKeyModal(false);
    setKeyType();
    setPasswordRequired(false);
    setTransationalPassword();
  }

  const createPixKey = () => {
    const bank = account.bank;

    if (!transationalPassword && bank !== "450") {
      toast.error("Digite a senha");
      return;
    }
    CreateKey(keyType, transationalPassword, navigate).then(response => {
      if(response.isCreated){
        MethodToCache(setIsWaitDBChange);
        MessageToCache("Nova chave criada com sucesso!")
        PullerGetAllPixKeyList();
        setCreatePixKeyModal(false)
      }
    });
  };

  return (
    <ReactModal
      isOpen={createPixKeyModal}
      className={"password-modal"}
      overlayClassName={"overlay-password-modal"}
    >
      <div className="create-pix-modal-container col-md-10">
        <div>
          <h1>Cadastre uma nova Chave</h1>
        </div>

        {passwordRequired ? (
          <>
            <div>
              <label>Senha</label>
              <div className="input-area col-md-12">
                <div className="col-md-1 input-area-icon">
                  <TbKey size={20} color="#000" />
                </div>
                <div className="col-md-11">
                  <input
                    type="password"
                    onChange={(e) => setTransationalPassword(e.target.value)}
                  />
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            <div>
              <label>Tipo de Chave</label>
              <div className="input-area col-md-8">
                <div className="col-md-1 input-area-icon">
                  <TbKey size={20} color="#000" />
                </div>
                <div className="col-md-11">
                  <select
                    name="select"
                    onChange={(e) => setKeyType(e.target.value)}
                  >
                    <option hidden value=""></option>
                    <option value="4">Chave aleatória</option>
                  </select>
                </div>
              </div>
            </div>

            <div className="mt-3">
              <label>Chave Pix</label>
              <div style={{ display: keyType === "4" ? "flex" : "none" }}>
                <p> A chave aleatória será gerada automaticamente pelo sistema </p>
              </div>
            </div>
          </>
        )}

        <div className="button-area">
          <button className="cancel-button" onClick={() => closeModal()}>Cancelar</button>
          <button className="confirm-button" onClick={() => confirm()}>Confirmar</button>
        </div>
      </div>
    </ReactModal>
  );
};

export default CadastrarChaveModal;
